/**
 * Airport Store
 * Manages airport data and provides utilities for airport operations
 */
import { useBookStore } from './book'
import { calculateDistance } from '~/helpers/coordinates-distance'
import airportService from '~/services/airportService'
import { arrayUnique } from '~/helpers'

export const useAirportStore = defineStore('AirportStore', {
  state: () => {
    return {
      airports: []
    }
  },
  getters: {
    calculateAirportDistanceFromCityCenter: state => (airportCode) => {
      const airport = state.airports.find(
        airport => airport.code === airportCode
      )
      if (!airport) {
        return null
      }

      return calculateDistance(
        airport.location.latitude,
        airport.location.longitude,
        airport.city.location.latitude,
        airport.city.location.longitude
      )
    },
    getAirport: state => (airportCode) => {
      return state.airports.find(airport => airport.code === airportCode)
    }
  },
  actions: {
    async getAirports (airportCodes) {
      const selectedAirportCodes = arrayUnique(airportCodes).filter(
        airportCode =>
          !this.airports.find(airport => airport.code === airportCode)
      )
      if (selectedAirportCodes.length === 0) {
        return
      }
      const { airports } = await airportService.fetch(selectedAirportCodes)
      this.airports = airports

      return airports
    },
    getCityName (airportCode) {
      const airport = this.getAirport(airportCode)
      if (!airport) {
        return null
      }

      return airport?.city?.name
    },
    getBookingAirports () {
      const bookStore = useBookStore()
      if (bookStore.isFlightLessBooking) {
        return []
      }
      const bookedOutwardFlight = bookStore.outwardFlight
      const bookedReturnFlight = bookStore.returnFlight

      // Check if flights exist and have required properties
      if (!bookedOutwardFlight?.destinationAirport || !bookedReturnFlight?.originAirport) {
        return []
      }

      return arrayUnique([
        bookedOutwardFlight.destinationAirport,
        bookedReturnFlight.originAirport
      ]).map(airportCode => this.getAirport(airportCode)).filter(Boolean)
    }
  }
})
